angular.module('dpw.services').factory('postMessageManager', ['PostMessageHost', function (PostMessageHost) {
    var postMessageHostMap = {};

    return {
        create: create,
        destroy: destroy,
    };

    function create(options) {
        var instance = new PostMessageHost(options);
        postMessageHostMap[instance.id] = instance;
        return instance;
    }

    function destroy(id) {
        var instance = postMessageHostMap[id];

        if (instance) {
            instance.dispose();
            delete postMessageHostMap[id];
        }
    }
}]);
